import React, { useEffect, useState } from 'react';
import { Toast } from 'antd-mobile';
import invariant from 'invariant';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import { qs } from '@/common/request';
import { getRechargeRecords, IRechargeRecord } from './api';
import { RESPONSE_CODE } from '@/common/config';
import './index.less';

const cssPreFix = 'recharge-records-container';

/** 支付方式 */
const payTypeMap: Record<string, string> = {
  '1': '微信',
  '2': '平台充值',
  '4': '支付宝',
};

/** 充值展示状态 */
const rechargeStatusMap: Record<number, string> = {
  1: '充值完成',
  2: '退款成功',
  3: '充值处理中...',
  4: '待完成支付',
};

const RechargeRecords: React.FC = () => {
  const location = useLocation();
  const { cardNo } = qs.parse(location.search);
  const [list, setList] = useState<IRechargeRecord[]>([]);

  useEffect(() => {
    document.title = '充值订单流水';
    getData();
  }, []);

  const getData = async () => {
    try {
      Toast.loading('loading...', 0);
      const result = await getRechargeRecords({ cardNo });
      invariant(result.code === RESPONSE_CODE.success, result?.msg || '请求失败');
      setList(result.data || []);
      Toast.hide();
    } catch (error: any) {
      Toast.info(error.message || '请求失败,请重试');
    }
  };

  return (
    <div className={cssPreFix}>
      {list.length === 0 ? (
        <div className={`${cssPreFix}-empty`}>近30天无充值记录</div>
      ) : (
        <div className={`${cssPreFix}-list`}>
          {list.map((item) => (
            <div className={`${cssPreFix}-item`} key={item.orderNo}>
              <div className={`${cssPreFix}-item-header`}>
                <span className={`${cssPreFix}-order-no`}>订单号：{item.orderNo}</span>
                <span className={`${cssPreFix}-status status-${item.rechargeStatus}`}>
                  {rechargeStatusMap[item.rechargeStatus] || '-'}
                </span>
              </div>
              <div className={`${cssPreFix}-row`}>
                <span>商品名称</span>
                <span>{item.sellName || '-'}</span>
              </div>
              <div className={`${cssPreFix}-row`}>
                <span>卡号</span>
                <span>{item.cardNo || '-'}</span>
              </div>
              <div className={`${cssPreFix}-row`}>
                <span>支付金额</span>
                <span className={`${cssPreFix}-amount`}>{item.payAmount || 0} 元</span>
              </div>
              <div className={`${cssPreFix}-row`}>
                <span>支付方式</span>
                <span>{payTypeMap[item.payType] || '-'}</span>
              </div>
              <div className={`${cssPreFix}-row`}>
                <span>支付时间</span>
                <span>{item.payTime ? dayjs(item.payTime).format('YYYY-MM-DD HH:mm:ss') : '-'}</span>
              </div>
              {item.rechargeStatus === 3 && (
                <div className={`${cssPreFix}-remark`}>备注：请耐心等待，或联系客服</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RechargeRecords;
